/**************************************************
 * Nombre:       Tarjeta_Categoria
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Tarjeta_Categoria = ({item, img}) => {
    const navigate = useNavigate()
    const {sCell} = useResponsive()

    return (
        <Grid
            onClick={() => navigate('/DetalleCat/' + item.nombre)}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                height: sCell ? 160 : 280,
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 49.67%, #000 100%), url(${img})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                px: 3,
                py: 3,
                color: '#fff',
                cursor: 'pointer'
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{fontSize: sCell ? 12 : 16}} >CATEGORÍA</Typography>
                    </Grid>


                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{
                            fontFamily: 'Dm Serif Display',
                            fontWeight: 400,
                            fontSize: sCell ? 24 : 32,
                            lineHeight: 1.1
                        }}>{item.nombre}</Typography>
                    </Grid>


                </Grid>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Categoria

